module.exports = __webpack_public_path__ + "media/images/wave-primary-5c8b333b293fe8cfe05b48fe3b250b26.png";